import { lowerCase, mapKeys } from 'lodash';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { DayOfWeek } from 'core/day-of-week';
import { pascalCase } from 'utils/pascal-case';
import {
  ApiConfiguration,
  ApiDayOfWeek,
  ApiWorkingDaysConfiguration,
} from './api-configuration';
import { Configuration } from './configuration';

export const asConfiguration = (from: ApiConfiguration): Configuration => {
  return {
    ...from,
    configMeta: {
      ...from.configMeta,
      categoryMandatory: from.configMeta.categoryMandatory || false,
    },
    due: {
      ...from.due,
      day: pascalCase(from.due.day) as DayOfWeek,
    },
    workingDays: mapKeys(
      from.workingDays,
      (_, key) => pascalCase(key) as DayOfWeek,
    ) as WorkingDaysConfiguration,
    integrationMeta: from.integrationMeta,
    lockSetting: from.lockSetting,
    approvalSetting: from.approvalSetting,
  };
};

export const asApiConfiguration = (from: Configuration): ApiConfiguration => {
  return {
    ...from,
    due: {
      ...from.due,
      day: lowerCase(from.due.day) as ApiDayOfWeek,
    },
    workingDays: mapKeys(
      from.workingDays,
      (_, key) => lowerCase(key) as DayOfWeek,
    ) as ApiWorkingDaysConfiguration,
  };
};
